<script setup lang="ts">
import AppLayout from '@/components/layout/AppLayout.vue'
</script>

<template>
  <AppLayout />
</template>

<style>
html.dark {
  color-scheme: dark;
}
</style>
